/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEmailTemplate } from './DatabaseEmailTemplate';
import {
    DatabaseEmailTemplateFromJSON,
    DatabaseEmailTemplateFromJSONTyped,
    DatabaseEmailTemplateToJSON,
} from './DatabaseEmailTemplate';

/**
 * 
 * @export
 * @interface SendEntryEmailRequest
 */
export interface SendEntryEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendEntryEmailRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SendEntryEmailRequest
     */
    message?: string;
    /**
     * 
     * @type {DatabaseEmailTemplate}
     * @memberof SendEntryEmailRequest
     */
    template?: DatabaseEmailTemplate;
    /**
     * 
     * @type {boolean}
     * @memberof SendEntryEmailRequest
     */
    readOnlyLink?: boolean;
}

/**
 * Check if a given object implements the SendEntryEmailRequest interface.
 */
export function instanceOfSendEntryEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function SendEntryEmailRequestFromJSON(json: any): SendEntryEmailRequest {
    return SendEntryEmailRequestFromJSONTyped(json, false);
}

export function SendEntryEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendEntryEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'template': !exists(json, 'template') ? undefined : DatabaseEmailTemplateFromJSON(json['template']),
        'readOnlyLink': !exists(json, 'readOnlyLink') ? undefined : json['readOnlyLink'],
    };
}

export function SendEntryEmailRequestToJSON(value?: SendEntryEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'message': value.message,
        'template': DatabaseEmailTemplateToJSON(value.template),
        'readOnlyLink': value.readOnlyLink,
    };
}

